import getUtmQueryParameters from './getUtmQueryParameters';

export default getUtmQueryParameters;
